/* eslint-disable no-empty-pattern */
/* Copyright (c) 2020 IceRock MAG Inc. Use of this source code is
 governed by the Apache 2.0 license. */

import React, { FC } from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';
import { t } from '../../../../../i18n';
import { usePathPrefix } from '../../../../../constants/hooks';

interface IProps {}

const RestocareCardsScreen: FC<IProps> = ({}) => {
  const prefix = usePathPrefix();

  return (
    <div className={classnames(styles.wrap)} id="cards">
      <div className={classnames('container', styles.container)}>
        <h2>{t('cases.restocare.cards.title')}</h2>
        <h4>{t('cases.restocare.cards.subtitle')}</h4>

        <img
          src={`${prefix}/case/restocare/line.svg`}
          alt="-- -"
          className={styles.line}
        />

        <div className={styles.cards}>
          <div className={styles.cards__card}>
            <img src={`${prefix}/case/restocare/truck.svg`} alt="truck" />

            <h5>{t('cases.restocare.cards.card_title_1')}</h5>

            <p>{t('cases.restocare.cards.card_text_1')}</p>
          </div>
          <div className={styles.cards__card}>
            <img src={`${prefix}/case/restocare/cashbox.svg`} alt="cashbox" />

            <h5>{t('cases.restocare.cards.card_title_2')}</h5>

            <p>{t('cases.restocare.cards.card_text_2')}</p>
          </div>
          <div className={styles.cards__card}>
            <img src={`${prefix}/case/restocare/address.svg`} alt="address" />

            <h5>{t('cases.restocare.cards.card_title_3')}</h5>

            <p>{t('cases.restocare.cards.card_text_3')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export { RestocareCardsScreen };
